import { motion } from 'framer-motion';
import { Check, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';

const features = [
  'Complete IRS transcript analysis',
  'Audit trigger assessment',
  'Comprehensive written findings report',
  'Personalized action plan',
  'Expert CPA review',
  '5-7 business day turnaround'
];

export default function PricingCard({ 
  edition, 
  name, 
  price, 
  description, 
  note,
  onSelect,
  loading = false,
  disabled = false
}) {
  const isClient = edition === 'client';
  
  return (
    <motion.div
      whileHover={{ y: -4 }}
      transition={{ duration: 0.2 }}
    >
      <Card 
        className={`relative overflow-hidden rounded-xl border shadow-sm hover:shadow-lg transition-shadow duration-300 ${
          isClient 
            ? 'border-[#00B4B4] bg-gradient-to-b from-[#F0FEFE] to-white' 
            : 'border-[#1A365D]/15 bg-white'
        }`}
        data-testid={`plan-card-${edition}`}
      >
        {isClient && (
          <div className="absolute top-4 right-4">
            <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-full bg-[#00B4B4] text-white">
              <Sparkles className="h-3 w-3" />
              33% Discount
            </span>
          </div>
        )}
        
        <CardHeader className="pb-4">
          <CardDescription className="text-[#1A365D]/70 uppercase tracking-wide text-xs font-semibold">
            {name}
          </CardDescription>
          <div className="flex items-baseline gap-1 mt-2">
            <span className="text-4xl font-bold text-[#1A365D] font-['IBM_Plex_Mono']">
              ${price}
            </span>
            <span className="text-slate-500 text-sm">one-time</span>
          </div>
          {note && (
            <p className="text-sm text-[#00B4B4] font-medium mt-1">{note}</p>
          )}
          <p className="text-sm text-slate-600 mt-2">{description}</p>
        </CardHeader>
        
        <CardContent className="pt-4 border-t border-slate-100">
          <ul className="space-y-3 mb-6">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-2">
                <Check className="h-5 w-5 text-[#00B4B4] flex-shrink-0 mt-0.5" />
                <span className="text-sm text-slate-600">{feature}</span>
              </li>
            ))}
          </ul>
          
          <motion.div whileHover={{ y: -1 }} whileTap={{ scale: 0.98 }}>
            <Button
              className={`w-full py-3 font-semibold ${
                isClient 
                  ? 'bg-[linear-gradient(160deg,_#00B4B4,_#2BC3C3)] text-white hover:brightness-[.98]'
                  : 'bg-[#1A365D] text-white hover:bg-[#2B4A76]'
              }`}
              onClick={() => onSelect(edition)}
              disabled={loading || disabled}
              data-testid={`plan-${edition}-cta-button`}
            >
              {loading ? 'Processing...' : 'Get Started'}
            </Button>
          </motion.div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
